import { useQuery } from '@tanstack/react-query';
import api from '../../api/client';
import { queryKeys } from './queryKeys';

export async function fetchPromptPresets(signal) {
  const [presetsRes, carouselRes] = await Promise.all([
    api.get('/presets', { signal }),
    api.get('/prompt-carousel', { signal }),
  ]);

  return {
    presets: presetsRes?.data?.presets || [],
    promptCarouselPresets: carouselRes?.data?.presets || [],
  };
}

export function usePromptPresetsQuery(presetId, { enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.promptPresets('all'),
    queryFn: ({ signal }) => fetchPromptPresets(signal),
    enabled,
    select: (data) => {
      const selectedPreset = presetId && presetId !== 'general'
        ? (data?.presets || []).find((preset) => String(preset.id) === String(presetId)) || null
        : null;

      return {
        ...data,
        selectedPreset,
      };
    },
  });
}
